module.exports = __webpack_public_path__ + "static/media/house-return.1fac4184.svg";